import React, { useState, useEffect } from "react";
import MultiSelectionDropdown from "../../components/component/MultiSelectionDropdown";
 
const FortigateConnexiumVlanTable = ({
  typeList,
  data,
  handleSelectMemberType,
  handleAccessEnable,
  handleSelectAccessMember,
  getHybridMembers,
  hasConflicts,
  dropdownValues,
  communicationType,
  secureData,
  vlanConfigurationType
}) => {
  const newData = { ...data };
 
  const [selectedMemberType, setSelectedMemberType] = useState({
    memberType: newData.memberType || (typeList && typeList[0]) || "",
    port: newData.port,
  });
  const [accessEnable, setAccessEnable] = useState(newData.enable);
  const [selectedAccessMember, setSelectedAccessMember] = useState(
    newData?.accessMembers?.vlan
  );
  const [selectedTrunkMember, setSelectedTrunkMember] = useState(newData);
 
  // Check if this port's original/default memberType from backend data is TRUNK
  const isDefaultTrunk = data?.memberType === "TRUNK";
 
  const getTrunkMembers = (members, port) => {
    // Persist locally so dropdown reflects chosen values
    setSelectedTrunkMember(prev => ({
      ...prev,
      hybridMembers: Array.isArray(members) ? members : [],
    }));
    if (typeof dropdownValues === 'function') {
      dropdownValues(members, port, communicationType);
    } else {
      console.warn('dropdownValues prop is missing or not a function in FortigateConnexiumVlanTable');
    }
  };
  // Sync local selectedAccessMember when parent updates data (e.g. switching to TRUNK defaults accessMembers to MGMT)
  useEffect(() => {
    const incomingAccessVlan = data?.accessMembers?.vlan;
    if (incomingAccessVlan && incomingAccessVlan !== selectedAccessMember) {
      setSelectedAccessMember(incomingAccessVlan);
    }
  }, [data?.accessMembers?.vlan, data?.memberType]);
 
  // Sync local selectedMemberType when parent updates data.memberType
  useEffect(() => {
    const incomingMemberType = data?.memberType;
    if (incomingMemberType && incomingMemberType !== selectedMemberType.memberType) {
      setSelectedMemberType(prev => ({
        ...prev,
        memberType: incomingMemberType,
      }));
    }
  }, [data?.memberType]);
 
  // Sync local selectedTrunkMember when parent updates data.hybridMembers (e.g. from FortigatePortVlanTable selection)
  // Also sync when memberType changes (e.g. switching from VLAN to TRUNK should pick up synced hybridMembers)
  useEffect(() => {
    const incoming = data?.hybridMembers || [];
    setSelectedTrunkMember(prev => {
      const current = prev?.hybridMembers || [];
      // Only update if the arrays actually differ to avoid infinite loops
      if (JSON.stringify(current.map(m => m?.vlan)) !== JSON.stringify(incoming.map(m => m?.vlan))) {
        return { ...prev, hybridMembers: incoming };
      }
      return prev;
    });
  }, [data?.hybridMembers, data?.memberType]);
 
  // Check if any OTHER port already has TRUNK/HYBRID_TRUNK selected
  const hasOtherTrunk = (() => {
    if (!secureData || !communicationType) return false;
    const list = Array.isArray(secureData[communicationType]) ? secureData[communicationType] : [];
    return list.some(row => row?.port !== newData.port && ["TRUNK", "HYBRID_TRUNK"].includes(row?.memberType));
  })();
  return (
    <tr className="text-center">
      <td width={"8%"}>{newData.port}</td>
      <td width={"8%"}>
        <div className="custom-control custom-checkbox">
          <input
            type="checkbox"
            className="custom-control-input asCompatible"
            name="connexiumVlanOptions"
            id={`fortigateConnexiumVlanOptions-${newData.id}`}
            value={accessEnable}
            checked={accessEnable}
            onChange={(e) => {
              setAccessEnable(e.target.checked);
              handleAccessEnable(e.target.checked, newData.port, communicationType);
            }}
          />
          <label
            className="custom-control-label line-height-25"
            htmlFor={`fortigateConnexiumVlanOptions-${newData.id}`}
          />
        </div>
      </td>
      <td width={"10%"}>
        <select
          className="col-sm-12 col-lg-12 col-md-12 col-xl-12 form-control form-control-sm"
          name="memberType"
          value={selectedMemberType.memberType}
          // disabled={isDefaultTrunk}
          onChange={(event) => {
            let member = event.target.value;
            handleSelectMemberType(member, newData.port, communicationType);
            setSelectedMemberType((prev) => ({
              ...prev,
              memberType: member,
              port: newData.port
            }));
          }}
        >
          {typeList?.map(type => (
            <option
              value={type}
              key={type}
              disabled={type === "TRUNK" && hasOtherTrunk && selectedMemberType.memberType !== "TRUNK"}
            >
              {type}
            </option>
          ))}
        </select>
      </td>
      <td width={"12%"}>
        <select
          className={`col-sm-12 col-lg-12 col-md-12 col-xl-12 form-control form-control-sm ${
            selectedMemberType.memberType === "TRUNK" && selectedAccessMember !== "MGMT"
              ? "is-mandatory"
              : selectedMemberType.memberType !== "TRUNK" && !hasConflicts.includes(selectedAccessMember)
              ? "is-mandatory"
              : ""
          }`}
          name="accessMember"
          value={selectedAccessMember}
          // disabled={isDefaultTrunk}
          onChange={(event) => {
            handleSelectAccessMember(event, newData.port, communicationType);
            setSelectedAccessMember(event.target.value);
          }}
        >
          {secureData?.securedCommunicationArchitecture?.map((data) => (
            <option key={data.id} value={data.vlan}
            disabled ={
              selectedMemberType.memberType === "TRUNK"
                ? data.vlan !== "MGMT"
                : !hasConflicts.includes(data.vlan)
            }
            >
              {data.vlan}
            </option>
          ))}
        </select>
      </td>
      <td width={"12%"} className="text-center">
       
        {["HYBRID_TRUNK", "TRUNK"].includes(selectedMemberType.memberType) && (
         
          <MultiSelectionDropdown
            secureData={secureData}
            trunkMembers={selectedTrunkMember}
            setSelectedTrunkMember={setSelectedTrunkMember}
            getHybridMembers={getHybridMembers}
            getTrunkMembers={getTrunkMembers}
            vlanConfigurationType={vlanConfigurationType}
            selectedMemberType={selectedMemberType}
            isDisabled={isDefaultTrunk}
          />
        )}
      </td>
    </tr>
  );
};
 
export default FortigateConnexiumVlanTable;